/** Espelha os tokens --motion-* do primitives.css. Usar em setTimeout/useSpring. */
export const MOTION = {
  fast:  120,
  base:  200,
  slow:  320,
  sheet: 280,
  page:  240,
} as const

export type MotionKey = keyof typeof MOTION
